<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a">AUTHOR’S NOTE</h2>
<p class="noindent1"><span class="stickup">S</span>ome characters and situations in this book were inspired by actual people and historical events, though I have used (and perhaps misused) them in entirely fictional ways. Seemingly, the most obviously “made-up” character in the book would have to be Trapper Nelson, of course. Rest assured, dear reader, that this amazing being lived and breathed and walked upon this earth.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// anote.vue?d4f252ea